var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.project)?_c('div',[(_vm.isPublicOrMember)?_c('ProjectLocationsMap'):_c('RequiresMember',{attrs:{"page":"Map"}})],1):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }